export const COLORS = {
  accent: '#007aff',
  success: 'green',
  error: 'red',
  screenBg: 'hsla(0, 0%, 0%, 0.55)',
  footerBg: 'hsla(0, 0%, 50%, 0.55)'
}